<app-index-layout [layoutData]="layoutData">
  <div box-body>
    <app-dynamic-form [questions]="questions" (formSubmit)="onSubmit($event)"> </app-dynamic-form>
  </div>
</app-index-layout>
